import { render, staticRenderFns } from "./tagSettings.vue?vue&type=template&id=57feb864&scoped=true&"
import script from "./tagSettings.vue?vue&type=script&lang=js&"
export * from "./tagSettings.vue?vue&type=script&lang=js&"
import style0 from "./tagSettings.vue?vue&type=style&index=0&id=57feb864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57feb864",
  null
  
)

export default component.exports